import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { MobileDrawer } from "@/components/layout/MobileDrawer";
import { StatusPanel } from "@/components/layout/StatusBadge52";
import { KewagBadge } from "@/components/common/KewagBadge";
import { SystemStatusProvider } from "@/lib/systemStatus";
import { loadF52Fonts } from "@/lib/f52Fonts";
import { NAV_ITEMS } from "@/lib/nav";
import { useAuth } from "@/context/AuthContext";
import "@/styles/control-v52.css";

export function ControlLayout() {
  const { pathname } = useLocation();
  const { env } = useAuth();
  const { t } = useTranslation();
  const isProd = !!env?.is_production;
  const [menuOpen, setMenuOpen] = useState(false);
  const menuBtnRef = useRef(null);
  const badgeRef = useRef(null);
  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const active = NAV_ITEMS.find((i) => (i.path === "/" ? pathname === "/" : pathname.startsWith(i.path)));

  useEffect(() => { loadF52Fonts(); }, []);
  useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <SystemStatusProvider>
      <div className="fundio-control-v52" data-testid="control-layout">
        <Sidebar />
        <div className="f52-main-col">
          <Topbar title={active ? t(`nav.items.${active.key}`) : t("layout.controlOs")} menuOpen={menuOpen}
            onMenu={() => setMenuOpen(true)} menuBtnRef={menuBtnRef} badgeRef={badgeRef} />
          {isProd ? (
            <div data-testid="env-live-banner" className="f52-env is-prod" role="note">
              <strong>{t("layout.liveTag")}</strong><span>{t("layout.liveText")}</span>
            </div>
          ) : (
            <div data-testid="demo-banner" className="f52-env" role="note">
              <strong>{t("layout.previewTag")}</strong><span>{t("layout.previewText")}</span>
            </div>
          )}
          <main className="f52-main p-4 sm:p-6 lg:p-8" id="main">
            <Outlet />
          </main>
          <div className="f52-badge-slot" data-testid="kewag-badge-slot"><KewagBadge /></div>
        </div>
        <MobileDrawer open={menuOpen} onClose={closeMenu} returnFocusRef={menuBtnRef} />
        <StatusPanel badgeRef={badgeRef} />
      </div>
    </SystemStatusProvider>
  );
}
